document.addEventListener('turbolinks:load', function () {
    if ($('.teams.show, .invitations.new, .invitations.create, .teams.new').length === 0) {
        return false
    }

    // Initialize permissions based on data attributes for each role
    function initializeRoleBasedPermissions() {
      // Set all checkboxes based on data-roles
      $(".permission-wrapper input[type='checkbox'][data-roles]").each(function() {
        const checkbox = $(this);
        const roles = checkbox.data('roles').split(' ');
        
        // Add data attributes for each role this permission belongs to
        roles.forEach(role => {
          if (role) {
            checkbox.attr(`data-role-${role}`, 'true');
          }
        });
      });
    }

    // Run initialization
    initializeRoleBasedPermissions();

  function openCollapse(collapseId) {
    const collapseElement = document.querySelector(collapseId);

    if (collapseElement) {
      if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
        const bsCollapse = new bootstrap.Collapse(collapseElement, { toggle: false });
        bsCollapse.show();
      } else {
        collapseElement.classList.add('show');
        collapseElement.setAttribute('aria-expanded', 'true');
      }
    }
  }

  function openAllCollapses() {
    const collapses = document.querySelectorAll('.collapse');

    collapses.forEach(collapse => {
      const collapseId = `#${collapse.id}`;
      if (collapse.id) {
        openCollapse(collapseId);
      }
    });
  }

    $('#user_kind').on('change', function () {
        $(".permission-wrapper input[type='checkbox']").prop('checked', false).trigger('change');
        $('#user_custom_role').addClass('d-none').attr('required', false);

        if ($(this).val() === 'admin') {
            $('.permission-access .apply-all').prop('checked', true).trigger('change');
            openAllCollapses()
        } else if ($(this).val() === 'plans_examiner') {
            $(".permission-wrapper input[type='checkbox'][data-role-plans_examiner]").prop('checked', true).trigger('change');
            openAllCollapses()
        } else if ($(this).val() === 'inspector') {
            $(".permission-wrapper input[type='checkbox'][data-role-inspector]").prop('checked', true).trigger('change');
            openAllCollapses()
        } else if ($(this).val() === 'permit_clerk') {
            $(".permission-wrapper input[type='checkbox'][data-role-permit_clerk]").prop('checked', true).trigger('change');
            openAllCollapses()
        } else if ($(this).val() === 'other') {
            $('#user_custom_role').removeClass('d-none').attr('required', true);
            $(".permission-wrapper input[type='checkbox'][data-role-permit_clerk]").prop('checked', true).trigger('change');
            openAllCollapses()
        }
    })

    function updateCheckbox(checkboxId) {
        $(checkboxId).prop('checked', true);
        $(checkboxId).trigger('change');
    }
});